import React, { Component } from "react";

import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ObjectUtils from "../../../../utils/ObjectUtils";
import SimpleRenderer from "./renderer/SimpleRenderer";

/**
 * Single row of the table question component for survey-view.
 */
class SortableTableRow extends Component {
  render() {
    const { rowAnswers, skipFirst, row, index, question, editRow, intl } = this.props;

    const colors = {
      "Option-0": "rgba(51, 189, 30, 0.4)",
      "Option-1": "rgba(255, 170, 0, 0.4)",
      "Option-2": "rgba(252, 0, 0, 0.4)",
      "Option-3": "rgba(51, 189, 30, 0.4)",
      "Option-4": "rgba(246, 255, 0, 0.4)",
      OtherAnswer: "rgba(0, 0, 0, 0.2)"
    };

    let result = [];

    for (let i = 0; i < question.columns.length; i++) {
      const column = question.columns[i];

      if (column.visible !== false) {
        if (column.name === "Spalten-2") {
          const tmp = rowAnswers.find((r) => r.colLabel === "Spalten-2");
          const col = colors[tmp?.name];
          result.push(
            <td
              key={`C${i}`}
              className={ObjectUtils.toKebabCase(column.type)}
              style={{ backgroundColor: col ? col : "transparent" }}
            >
              <SimpleRenderer question={question} collection={rowAnswers} row={row} column={column} intl={intl}/>
            </td>
          );
        } else {
          result.push(
            <td key={`C${i}`} className={ObjectUtils.toKebabCase(column.type)}>
              <SimpleRenderer question={question} collection={rowAnswers} row={row} column={column} intl={intl}/>
            </td>
          );
        }
      }
    }

    return (
      <tr key={`tableRow-${index}`} onClick={editRow ? () => editRow(index) : undefined}>
        <td key={`dynamic-row-number${index}`}>{index + 1}</td>

        {!skipFirst && (
          <td key={index}>
            {row.required ? " * " : " "}
            {row.text}
            {row.infoText && (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="tooltip" className="survey-tooltip">
                    {row.infoText}
                  </Tooltip>
                }
              >
                <FontAwesomeIcon icon={faInfoCircle} />
              </OverlayTrigger>
            )}
          </td>
        )}

        {result}
      </tr>
    );
  }
}

SortableTableRow.propTypes = {
  question: PropTypes.object.isRequired,
  rowAnswers: PropTypes.array.isRequired,
  editRow: PropTypes.func,
  index: PropTypes.number,
  row: PropTypes.object,
  skipFirst: PropTypes.bool
};

export default SortableTableRow;
